import React, { useRef } from 'react';
import { observer, useAsObservableSource } from 'mobx-react-lite';
import { useAppStateContext } from '../../../AppState/AppState';
import {
    CampaignName,
    ContentContainer,
    DatesContainer,
    DateTitle,
    DateValue,
    DateWrapper,
    ActiveLabel,
} from '../../LandingPage/LPListItem/LPListItem.style';
import { ImageContainer, ImageWrapper } from './NavigationLinkElement.style';
import moment from 'moment';
import { Checkbox } from 'src/components/Checkbox/Checkbox';
import { observable, makeAutoObservable } from 'mobx';
import {
    NavigationLinkGetType,
    TopNavigationLinkState,
} from 'src/AppState/TopNavigationLinkState/TopNavigationLinkState';
import { Button } from 'src/domains/layouts/shared/buttons/Button';
import { ListItem, ActionsWrapper, TrashIconWrapper } from 'src/domains/layouts/shared/cms/list/List.style';

interface linkItemPropsType {
    navigationLink: NavigationLinkGetType;
}

class State {
    @observable copySuccess = false;
    constructor(
        private readonly topNavigationLinkState: TopNavigationLinkState,
        private readonly linkItem: NavigationLinkGetType,
        public readonly textAreaRef: React.RefObject<HTMLTextAreaElement>
    ) {
        makeAutoObservable(this);
    }

    onChangePageToEdit = (): void => {
        this.topNavigationLinkState.setPage('edit');
        this.topNavigationLinkState.setEditedLink(this.linkItem);
    };

    onRemove = (): void => {
        this.topNavigationLinkState.onRemove(this.linkItem);
    };

    changeActiveFlag = (): void => {
        this.topNavigationLinkState.setActiveFlag(this.linkItem);
    };
}

export const LinkItemListItem = observer(({ navigationLink }: linkItemPropsType) => {
    const { topNavigationLinkState } = useAppStateContext();
    const linkItemIn = useAsObservableSource(navigationLink);
    const textAreaRef = useRef<HTMLTextAreaElement>(null);
    const [state] = React.useState(() => new State(topNavigationLinkState, linkItemIn, textAreaRef));
    const startDate = moment(navigationLink.date_from).format('DD-MM-YYYY HH:mm:ss');
    const endDate = moment(navigationLink.date_to).format('DD-MM-YYYY HH:mm:ss');
    const isEdited = navigationLink.id === topNavigationLinkState.editedLink?.id;

    return (
        <ListItem
            isEdited={isEdited}
            boxHeight='134px'
            data-test='link-item'
            direction='row'
        >
            <ImageContainer>
                <ImageWrapper imgSrc={navigationLink.img_url ?? ''} />
            </ImageContainer>

            <ContentContainer>
                <CampaignName data-test='link-name'>{navigationLink.title}</CampaignName>
                <DatesContainer>
                    <DateWrapper isStart>
                        <DateTitle>Scheduled start</DateTitle>
                        <DateValue>{startDate}</DateValue>
                    </DateWrapper>
                    <DateWrapper>
                        <DateTitle>Scheduled finish</DateTitle>
                        <DateValue>{endDate}</DateValue>
                    </DateWrapper>
                </DatesContainer>

                <ActionsWrapper>
                    <Checkbox
                        labelSide='right'
                        onChange={state.changeActiveFlag}
                        isChecked={navigationLink.is_active}
                        isDisabled={false}
                    >
                        <ActiveLabel>Active</ActiveLabel>
                    </Checkbox>
                    <ActionsWrapper>
                        <Button
                            version='secondary'
                            size='small'
                            onClick={state.onChangePageToEdit}
                        >
                            Edit
                        </Button>
                        <TrashIconWrapper onClick={state.onRemove} />
                    </ActionsWrapper>
                </ActionsWrapper>
            </ContentContainer>
        </ListItem>
    );
});
